import { render, staticRenderFns } from "./ListAsetTanahPage.vue?vue&type=template&id=0f58d000"
import script from "./ListAsetTanahPage.vue?vue&type=script&lang=js"
export * from "./ListAsetTanahPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports